<div class="filter-section">
  <div class="date-filters">
    <label>
      Start Date:
      <input type="date" [(ngModel)]="startDate" />
    </label>

    <label>
      End Date:
      <input type="date" [(ngModel)]="endDate" />
    </label>
  </div>

  <div class="filter-buttons">
    <button mat-raised-button color="primary" (click)="page = 1; fetchLoads()" [disabled]="isLoading">
      <mat-icon *ngIf="isLoading">refresh</mat-icon>
      {{ isLoading ? 'Loading...' : 'Apply Filter' }}
    </button>
  </div>
</div>

<!-- Loads List -->
<mat-card class="loads-card" *ngIf="loads.length > 0">
  <h3 class="card-title">Available Loads</h3>
  
  <div class="loads-list">
    <div *ngFor="let load of loads" class="load-item" (click)="viewLoadReport(load)">
      <div class="load-info">
        <div class="load-name">{{ load.name }}</div>
        <div class="load-details">
          <span class="load-state">{{ load.state }}</span>
          <span class="load-date">{{ load.createdAt | date:'short' }}</span>
        </div>
        <div class="load-assignments" *ngIf="load.deliveryBoyName || load.salesManName">
          <span *ngIf="load.deliveryBoyName" class="delivery-boy">Delivery: {{ load.deliveryBoyName }}</span>
          <span *ngIf="load.salesManName" class="sales-man">Sales: {{ load.salesManName }}</span>
        </div>
            <div class="load-note" *ngIf="load.note">
              <span class="note-label">Note: </span>
              <span class="note-text" [title]="load.note">{{ load.note }}</span>
            </div>
      </div>
      <mat-icon class="view-icon">visibility</mat-icon>
    </div>
  </div>

  <div class="pagination-controls">
    <button mat-button (click)="prevPage()" [disabled]="page === 1">Previous</button>
    <span>Page {{ page }} of {{ totalPages }}</span>
    <button mat-button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>
</mat-card>

<!-- Load Report Display -->
<mat-card class="report-card" *ngIf="selectedLoad && loadReportData">
  <div class="report-header">
    <h3 class="card-title">Load Report: {{ selectedLoad.name }}</h3>
    <div class="report-actions">
      <button mat-raised-button color="primary" (click)="exportToExcel()">
        <mat-icon>table_chart</mat-icon>
        Export Excel
      </button>
      <button mat-button (click)="clearReport()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
  </div>

  <!-- Load Summary -->
  <div class="load-summary" *ngIf="loadReportData.load">
    <div class="summary-item">
      <label>State:</label>
      <span class="state-badge" [ngClass]="'state-' + loadReportData.load.state">
        {{ loadReportData.load.state }}
      </span>
    </div>
    <div class="summary-item" *ngIf="loadReportData.load.deliveryBoyName">
      <label>Delivery Boy:</label>
      <span>{{ loadReportData.load.deliveryBoyName }}</span>
    </div>
    <div class="summary-item" *ngIf="loadReportData.load.salesManName">
      <label>Sales Man:</label>
      <span>{{ loadReportData.load.salesManName }}</span>
    </div>
  </div>

  <!-- Report Table -->
  <div class="table-wrapper" *ngIf="loadReportData.rows && loadReportData.rows.length > 0">
    <table mat-table [dataSource]="loadReportData.rows" class="report-table">
      <!-- SL No Column -->
      <ng-container matColumnDef="slno">
        <th mat-header-cell *matHeaderCellDef>SL No</th>
        <td mat-cell *matCellDef="let row">{{ row.slno }}</td>
      </ng-container>

      <!-- Customer Name Column -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let row">{{ row.customerName || '-' }}</td>
      </ng-container>

      <!-- Order Number Column -->
      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef>Order #</th>
        <td mat-cell *matCellDef="let row">{{ row.orderNumber || '-' }}</td>
      </ng-container>

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Order Amount</th>
        <td mat-cell *matCellDef="let row">{{ formatCurrency(row.amount) }}</td>
      </ng-container>

      <!-- Invoice Number Column -->
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef>Invoice #</th>
        <td mat-cell *matCellDef="let row">{{ row.invoiceNumber || '-' }}</td>
      </ng-container>

      <!-- Invoice Amount Column -->
      <ng-container matColumnDef="invoiceAmount">
        <th mat-header-cell *matHeaderCellDef>Invoice Amount</th>
        <td mat-cell *matCellDef="let row">{{ formatCurrency(row.invoiceAmount) }}</td>
      </ng-container>

      <!-- Old Unpaid Invoices Column -->
      <ng-container matColumnDef="oldUnpaidInvoiceNumbers">
        <th mat-header-cell *matHeaderCellDef>Old Unpaid Invoices</th>
        <td mat-cell *matCellDef="let row">{{ formatOldUnpaidInvoices(row.oldUnpaidInvoiceNumbers) }}</td>
      </ng-container>

      <!-- Old Unpaid Total Column -->
      <ng-container matColumnDef="oldUnpaidTotalAmount">
        <th mat-header-cell *matHeaderCellDef>Old Unpaid Total</th>
        <td mat-cell *matCellDef="let row">{{ formatCurrency(row.oldUnpaidTotalAmount) }}</td>
      </ng-container>

      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let row" class="total-cell">{{ formatCurrency(row.total) }}</td>
      </ng-container>

      <!-- Notes Column -->
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef> Notes </th>
        <td mat-cell *matCellDef="let row">
          <ng-container >
            <input [(ngModel)]="row.notes" />
          </ng-container>
          <ng-template #displayMode>
            {{ row.notes || '-' }}
          </ng-template>
        </td>
      </ng-container>
      

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Totals Summary -->
  <div class="totals-summary" *ngIf="loadReportData.totals">
    <div class="totals-row">
      <span class="totals-label">Total Invoice Amount:</span>
      <span class="totals-value">{{ formatCurrency(loadReportData.totals.invoiceAmount) }}</span>
    </div>
    <div class="totals-row">
      <span class="totals-label">Total Old Unpaid:</span>
      <span class="totals-value">{{ formatCurrency(loadReportData.totals.oldUnpaidTotalAmount) }}</span>
    </div>
    <div class="totals-row grand-total">
      <span class="totals-label">Grand Total:</span>
      <span class="totals-value">{{ formatCurrency(loadReportData.totals.total) }}</span>
    </div>
  </div>

  <!-- No Data Message -->
  <div class="no-data" *ngIf="!loadReportData.rows || loadReportData.rows.length === 0">
    <mat-icon>info</mat-icon>
    <p>No report data available for this load.</p>
  </div>
</mat-card>

<!-- Loading Spinner for Report -->
<div class="loading-container" *ngIf="isReportLoading">
  <mat-spinner></mat-spinner>
  <p>Loading report data...</p>
</div>

<!-- No Loads Message -->
<div class="no-loads" *ngIf="!isLoading && loads.length === 0">
  <mat-icon>inbox</mat-icon>
  <p>No loads found for the selected date range.</p>
</div>
